import { ICompositeProductApi } from '@canvas-logic/clp-sdk';
import { ElementState, ConfiguratorUIElementStates, ContainerStateBase } from '@/elements/base/ElementState';
import {
  IUICfgAttributesContainerElementOptions,
  IUICfgComponentContainerElementOptions,
  IUiCfgContainer,
  IUiCfgContainerItem,
  IUICfgProductsContainerElementOptions,
} from '@canvas-logic/clp-api-types';
import { getContainerUIElement, getUIElement } from '@/elements/elementStorage';

/**
 * The four members of `IUiCfgContainer` carry different settings bags: `productsSettings`
 * exists only on the Product Merge container, `componentsSettings`/`attributesSettings` on
 * every member except that one. Reading an absent bag yields `undefined`, which is what
 * `init` has always been handed; this alias records the shape the call site assumes rather
 * than changing what is passed.
 */
type ContainerSettingsBags = {
  componentsSettings: IUICfgComponentContainerElementOptions;
  productsSettings: IUICfgProductsContainerElementOptions;
  attributesSettings: IUICfgAttributesContainerElementOptions;
};

export function createConfiguratorUIElementState(
  api: ICompositeProductApi,
  element: IUiCfgContainerItem,
  container: IUiCfgContainer,
): ElementState {
  const settings = container as unknown as ContainerSettingsBags;
  const state = getUIElement(element.kind, element.type).init({
    api,
    viewElement: element,
    componentSettings: settings.componentsSettings,
    productsSettings: settings.productsSettings,
    attributeSettings: settings.attributesSettings,
  });

  return state;
}

export function createConfiguratorContainerUIElementState(
  api: ICompositeProductApi,
  element: IUiCfgContainer,
  children: Array<ConfiguratorUIElementStates>,
): ContainerStateBase {
  const state = getContainerUIElement(element.kind, element.type).init({
    api,
    viewElement: element,
    children,
  });

  return state;
}

export function templateValue(template: string, object: Record<string, string>) {
  return template.replace(/\{(.*?)\}/g, (match, key) => {
    if (!(key in object)) {
      throw new Error(`Invalid key ${key} in template: "${template}"`);
    }
    return object[key].toString();
  });
}
